
// Dynamically import all translation modules (eagerly) from sub‑folders
const modules = import.meta.glob('./*/*.ts', { eager: true });

// Shape of the exported messages object
type TranslationMap = Record<string, string>;
interface LangMessages {
  translation: TranslationMap;
}
const messages: Record<string, LangMessages> = {};

// Process each matched file
Object.keys(modules).forEach((path) => {
  // Expect paths like "./en/common.ts"
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (!match) {
    // If the path does not conform, skip it (prevents runtime crashes)
    console.warn(`Skipping unexpected module path: ${path}`);
    return;
  }

  const [, lang] = match;
  const module = modules[path] as Record<string, unknown>;

  // Ensure a container exists for the language
  if (!messages[lang]) {
    messages[lang] = { translation: {} };
  }

  // Merge all named exports that are plain objects
  Object.entries(module).forEach(([key, value]) => {
    if (key === 'default') return; // default export handled separately
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      messages[lang].translation = {
        ...messages[lang].translation,
        ...(value as TranslationMap),
      };
    }
  });

  // Also merge the default export if it exists and is an object
  if (module.default && typeof module.default === 'object' && !Array.isArray(module.default)) {
    messages[lang].translation = {
      ...messages[lang].translation,
      ...(module.default as TranslationMap),
    };
  }
});

export default messages;
